import { createAction, createAsyncThunk } from "@reduxjs/toolkit";
import type { Dependencies } from "@redux/store";
import type { ReviewFundingRequestBody } from "@shared-kernel/application/ports/admin/admin-repository";

export const reviewFundingRequest = createAsyncThunk<
  void,
  { id: string; body: ReviewFundingRequestBody },
  { extra: Partial<Dependencies> }
>(
  "fundingRequests/reviewFundingRequest",
  async ({ id, body }: { id: string; body: ReviewFundingRequestBody }, { extra: { adminRepository } }) => {
    return adminRepository!.review(id, body);
  },
);

export const resetReviewFundingRequest = createAction("fundingRequests/resetReviewFundingRequest");
